(() => {
  function initialize() {
    const main = document.getElementById('MainContent');
    if (!main || main.dataset.lgReviewLinks) return;
    main.dataset.lgReviewLinks = 'true';
    const section = main.querySelector('[data-lg-review-section="reviews"]');
    let pendingRating = null;
    let selectedRating = null;
    let queued = false;
    const native = selector => section?.querySelector(selector);
    const decorate = () => {
      const feed = main.querySelector('#lg-product-reviews');
      if (!feed) return;
      main.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
        badge.setAttribute('role', 'link');
        badge.setAttribute('tabindex', '0');
        badge.setAttribute('aria-controls', feed.id);
        badge.style.cursor = 'pointer';
      });
      main.querySelectorAll('[data-widget="review-snippet"]').forEach(widget => {
        if (!widget.querySelector('.jdgm-rev-snippet-card') || widget.querySelector('.lg-review-snippet-link')) return;
        const link = document.createElement('a');
        link.className = 'lg-review-snippet-link';
        link.href = '#lg-product-reviews';
        link.textContent = 'Read all reviews';
        widget.append(link);
      });
      section?.querySelectorAll('.jm-reviewer-info__details > .jm-cluster > span.jm-text:not(.jm-reviewer-info__name):not(.lg-review-date)').forEach(element => {
        const match = element.textContent.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (!match || Number(match[1]) > 12 || Number(match[2]) > 31) return;
        const date = new Date(Date.UTC(Number(match[3]), Number(match[1]) - 1, Number(match[2])));
        element.classList.add('lg-review-date');
        const desktop = document.createElement('span');
        desktop.className = 'lg-review-date-desktop';
        desktop.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date);
        const mobile = document.createElement('span');
        mobile.className = 'lg-review-date-mobile';
        mobile.textContent = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date);
        element.replaceChildren(desktop, mobile);
      });
      const tabs = section?.querySelectorAll('.jdgm-tab');
      const sort = native('.jm-sort-filter__select');
      const customSort = native('[data-lg-sort]');
      const write = native('.jm-action-buttons__button');
      if (!section || !sort || !customSort || !write || tabs.length < 2) return;
      const signature = Array.from(sort.options).map(o => `${o.value}:${o.text}`).join('|');
      if (customSort.dataset.options !== signature) {
        customSort.replaceChildren(...Array.from(sort.options, option => new Option(option.text, option.value)));
        customSort.dataset.options = signature;
      }
      customSort.value = sort.value;
      const activeTab = tabs[1].getAttribute('aria-selected') === 'true' ? 'store' : 'product';
      section.dataset.lgActiveTab = activeTab;
      section.querySelectorAll('[data-lg-tab]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgTab === activeTab)));
      const summary = native('.jm-average-rating-display');
      const values = summary?.querySelectorAll('.jm-text');
      {
        const score = native('[data-lg-score]');
        const count = native('[data-lg-count]');
        const number = values?.[0]?.textContent.trim() || '0';
        const storeCount = native('[data-widget="review"]')?.getAttribute('data-shop-reviews-count');
        const productCount = tabs[0].textContent.match(/\(([\d,]+)\)/)?.[1]?.replaceAll(',', '') || '0';
        const countText = `${activeTab === 'store' ? storeCount || '0' : productCount} reviews`;
        if (score.textContent !== number) score.textContent = number;
        const reviewCount = parseInt(countText.replace(/[^0-9]/g, ''), 10);
        section.dataset.lgReviewCount = String(reviewCount);
        const scope = activeTab === 'product' ? ` of this ${section.dataset.lgProductNoun || 'product'}` : ' of the shop';
        if (count.dataset.value !== countText + scope) {
          count.replaceChildren(document.createTextNode(reviewCount === 0 ? 'No reviews yet' : countText));
          const suffix = document.createElement('span');
          suffix.className = 'lg-review-score__scope';
          suffix.textContent = scope;
          if (reviewCount !== 0) count.append(suffix);
          count.dataset.value = countText + scope;
        }
        native('.lg-review-score__stars')?.setAttribute('aria-label', `${number} out of 5 stars`);
      }
      if (!section.dataset.lgResponsiveReady) {
        const mobile = window.matchMedia('(max-width:749px)');
        const updateRatingsDisclosure = () => { native('[data-lg-ratings]').open = !mobile.matches; };
        updateRatingsDisclosure();
        mobile.addEventListener('change', updateRatingsDisclosure);
        section.dataset.lgResponsiveReady = 'true';
      }
      section.classList.add('lg-review-enhanced');
      section.querySelectorAll('[data-lg-rating]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgRating === selectedRating)));
    };
    const applyRating = (rating, attempt = 0) => {
      const filter = native('.jm-custom-answer-filter');
      if (!filter) return;
      if (filter.getAttribute('aria-expanded') !== 'true') filter.click();
      const input = document.querySelector(`input[name="rating-filter"][value="${rating}"]`);
      if (!input) {
        if (attempt < 30) requestAnimationFrame(() => applyRating(rating, attempt + 1));
        else { pendingRating = null; section.classList.remove('lg-review-enhanced'); }
        return;
      }
      if (selectedRating === rating) {
        document.querySelector('.jm-filter-panel__clear-btn')?.click();
        selectedRating = null;
      } else {
        input.click();
        selectedRating = rating;
      }
      pendingRating = null;
      requestAnimationFrame(() => {
        if (filter.getAttribute('aria-expanded') === 'true') filter.click();
        if (window.matchMedia('(max-width:749px)').matches) native('[data-lg-ratings]')?.removeAttribute('open');
        decorate();
      });
    };
    const activate = event => {
      if (!(event.target instanceof Element)) return;
      const target = event.target.closest('.jdgm-prev-badge, a[href="#lg-product-reviews"]');
      if (target && main.contains(target)) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        const heading = main.querySelector('#lg-product-reviews')?.closest('.lg-review-section')?.querySelector('h2');
        if (!heading) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const productTab = native('.jdgm-tab');
        if (productTab?.getAttribute('aria-selected') === 'false') {
          productTab.click();
          selectedRating = null;
        } else if (selectedRating !== null) applyRating(selectedRating);
        heading.focus({ preventScroll: true });
        heading.closest('.lg-review-section').scrollIntoView({ behavior: 'instant', block: 'start' });
        return;
      }
      if (event.type !== 'click' || !section?.contains(event.target)) return;
      const write = event.target.closest('[data-lg-write]');
      if (write) { native('.jm-action-buttons__button')?.click(); return; }
      const tab = event.target.closest('[data-lg-tab]');
      if (tab) {
        selectedRating = null;
        const tabs = section.querySelectorAll('.jdgm-tab');
        tabs[tab.dataset.lgTab === 'store' ? 1 : 0]?.click();
        requestAnimationFrame(decorate);
        return;
      }
      const pill = event.target.closest('[data-lg-rating]');
      if (pill && pendingRating === null) {
        pendingRating = pill.dataset.lgRating;
        applyRating(pendingRating);
      }
    };
    main.addEventListener('click', activate, true);
    main.addEventListener('keydown', activate, true);
    main.addEventListener('change', event => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-lg-sort]')) return;
      const sort = native('.jm-sort-filter__select');
      if (!sort) return;
      sort.value = event.target.value;
      sort.dispatchEvent(new Event('change', { bubbles: true }));
    });
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; decorate(); });
    }).observe(main, { childList: true, subtree: true });
    decorate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
